(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Responsive Nav

  let menuItems = document.querySelectorAll('.header-mobile-inner .header_main > li');

  if (menuItems) {
    menuItems.forEach((item) => {
      let dropdownBtn = item.querySelector(".menu_dropdown")
      if (dropdownBtn) {
        dropdownBtn.addEventListener('click', (e) => {
            item.classList.toggle('dropdown-active');          
        });
      }
    });

    let submenuDropdown = document.querySelectorAll('.simple-dropdown-submenu').forEach((item) => {
      item.addEventListener('click', (e) => {
        if (item.querySelector('.simple-dropdown-menu')) {
          item.querySelector('.simple-dropdown-menu').classList.toggle('dropdown-active');
        }
      });
    });
  }

  document.addEventListener('keydown', (e) => {
    let searchBar = document.querySelector('.search-wrapper');

    if (e.key === 'Escape') {
      if (searchBar) {
        searchBar.setAttribute('class', 'search-wrapper fade-in-up');
      }
    }

    if (e.key === 'Enter') {
      let searchButton = document.querySelector('.header-right .search-user');

      if (searchButton && e.target == searchButton) {
        searchBar.setAttribute('class', 'search-wrapper fade-in-up show-search');
      }
    }
  });

  // Aria Modals

  function ariaClose(closeEl, btnEl) {
    let close = document.querySelector(`${closeEl}`);

    if (close) {
      let btn = document.querySelector(`${btnEl}`);
      close.addEventListener('click', (e) => {
        btn.setAttribute('aria-expanded', 'false');
      });
    }
  }

  ariaClose('.tracker-close', '.top-location-currency .small-box');
  ariaClose('.cart-drawer .cart-drawer-close', '.cart-icon .open-drawer');
  ariaClose('.search-box-wrap .close', '.search-user');

  let menuMain = document.querySelector('.header_main');

  if (menuMain) {
    menuMain.querySelectorAll('li').forEach((item) => {
      if (item.querySelector('.dropdown-menu')) {
        let link = item.querySelector('.menu_link');
        link.addEventListener('keyup', (e) => {
          if (e.key == 'ArrowDown') {
            item.querySelector('.dropdown-menu').classList.add('menu_active');
            link.setAttribute('aria-expanded', 'true');
          } else if (e.key == 'ArrowUp') {
            item.querySelector('.dropdown-menu').classList.remove('menu_active');
            link.setAttribute('aria-expanded', 'false');
          }
        });
        item.querySelectorAll('ul li').forEach((subItem) => {
          let subLink = subItem.querySelector('.menu_sublink');
          if (subItem.querySelector('.simple-dropdown-menu')) {
            subLink.addEventListener('keyup', (e) => {
              if (e.key == 'ArrowDown') {
                subLink.setAttribute('aria-expanded', 'true');
                subItem.querySelector('.simple-dropdown-menu').classList.add('submenu_active');
              } else if (e.key == 'ArrowUp') {
                subLink.setAttribute('aria-expanded', 'false');
                subItem.querySelector('.simple-dropdown-menu').classList.remove('submenu_active');
              }
            });
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  Shopify.queryParams = {};

  if (location.search.length) {
    var params = location.search.substr(1).split('&');
    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');
      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }
  const next = document.querySelector('.next');
  if (next != null) {
    let nextContent = next.children[0];
    nextContent.innerHTML = `
    <img src="https://cdn.shopify.com/s/files/1/0441/3027/1389/files/navigation_next.svg?v=1673520127" width="" height=""  alt="shopify">
    `;
  }

  const prev = document.querySelector('.prev');
  if (prev != null) {
    let prevContent = prev.children[0];
    prevContent.innerHTML = `
    <img src="https://cdn.shopify.com/s/files/1/0441/3027/1389/files/navigation.svg?v=1673519308" width="" height=""  alt="shopify">
    `;
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      let sidebar = document.querySelector('#collection_sidebar');
      if (sidebar) {
        sidebar.setAttribute('class', '');
      }
    }
  });

  let filterBtns = document.querySelectorAll('.tab-check');

  if (filterBtns) {
    filterBtns.forEach((btn) => {
      btn.addEventListener('keyup', (e) => {
        if (e.key == 'Enter' || e.key == ' ') {
          btn.querySelector('input').click();
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal-main"] && !Shopify.designMode) return;
  try {
    
  let closeBtn = document.querySelector('#modal_close');
  let modalMain = document.querySelector('#modal_main');

  setTimeout(() => {
    modalMain.classList.add('modal-active');
  }, 5000);

  closeBtn.addEventListener('click', () => {
    modalMain.classList.add('hide-modal');
    sessionStorage.setItem('modalStatus', 'hidden');
  });

  window.addEventListener('keyup', (e) => {
    if (e.key == 'Escape') {
      modalMain.classList.add('hide-modal');
      sessionStorage.setItem('modalStatus', 'hidden');
    }
  });

  if (sessionStorage.getItem('modalStatus') == 'hidden') {
    modalMain.classList.add('hide-modal');
  }

  } catch(e) { console.error(e); }
})();
})();
